import { useTranslation } from 'react-i18next';
import { MenuItem, InputLabel, FormControl } from '@mui/material';
import SearchableSelect from 'components/Forms/searchable/SearchableSelect';
import { UOM_OPTIONS } from 'components/MenuNew/FormView/Inventory/configs';

const InventoryUnit = ({ unit, handleSelect }) => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth size="small">
      <InputLabel shrink htmlFor="inventory-unit-select">
        {t('Unit of Measure')}
      </InputLabel>
      <SearchableSelect
        label={t('Unit of Measure')}
        id="inventory-unit-select"
        name="unit"
        value={unit}
        onChange={handleSelect}
        displayEmpty
        sx={{ width: '100%' }}
        size="small"
        InputLabelProps={{ shrink: true }}
      >
        {UOM_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </SearchableSelect>
    </FormControl>
  );
};

export default InventoryUnit;
